







import { Component, Vue, Prop } from "vue-property-decorator";
import agreementTemplate from "@components/common/agreement/pageTemplate.vue";
import UK from "./register/UK/index.vue";
import CZ from "./register/CZ/index.vue";
import DE from "./register/DE/index.vue";
import ES from "./register/ES/index.vue";
import FR from "./register/FR/index.vue";
import IT from "./register/IT/index.vue";
import PL from "./register/PL/index.vue";
import SAU from "./register/SAU/index.vue";
import UAE from "./register/UAE/index.vue";
@Component({
  components: {
    agreementTemplate,
    UK,
    CZ,
    DE,
    ES,
    FR,
    IT,
    PL,
    SAU,
    UAE
  }
})
export default class RegisterAgreement extends Vue {
  private get nation() {
    return this.$route.params.nation || "";
  }
}
